import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as GlobeInsideCircle } from "../../../../assets/svg/globe-inside-circle.svg";
import { ReactComponent as Globe } from "../../../../assets/svg/globe.svg";
import { IconWithText } from "../IconWithText";

const useStyles = makeStyles(() => ({
  restrictedCountriesContainer: {
    marginTop: 16,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: "16px 32px 16px 32px",
  },
  content: {
    display: "flex",
    columnGap: 8,
    alignItems: "center",
    "& + &": {
      marginTop: 11,
    },
  },
  name: {
    fontSize: 17,
    color: "#858997",
    wordBreak: "break-word",
  },
}));

interface RestrictedCountriesShowProps {
  restrictedCountries: string[];
}

export const RestrictedCountriesWidget: FC<RestrictedCountriesShowProps> = ({
  restrictedCountries,
}) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={GlobeInsideCircle} title="Restricted Countries" />
      <div className={classes.restrictedCountriesContainer}>
        {restrictedCountries.map((country) => (
          <div key={country} className={classes.content}>
            <Globe />
            <div className={classes.name}>{country}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
